module.exports = "/_next/static/images/Hero-535387553e1fb1c67f3fe5183c74f55d.webp";